module.exports = __webpack_public_path__ + "assets/img/person_icon_f.54ed8e63.png";